const pageSizes = [10, 15, 20, 25, 50].map((e) => ({
  name: e.toString(),
  id: e.toString(),
}));
export default pageSizes;
